export const AGENDA_TRANSLATION_NAMESPACE = "agenda";

export const AGENDA_TK = "AGENDA_TK";
export const AGENDA_SPONSORED_AD_TK = "AGENDA_SPONSORED_AD_TK";
